import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Lottie from 'react-lottie';
import { useMediaQuery } from "@mui/material";
import animationData from '../LandingPage/animateds.json';
import Step1Image from '/Images/step1xcrow.svg';
import Step2Image from '/Images/step2xcrow.svg';
import Step3Image from '/Images/step3xcrow.svg';
import Step4Image from '/Images/step4xcrow.svg';
import Step5Image from '/Images/step5xcrow.svg';
import Step6Image from '/Images/step6xcrow.svg';

const Platform = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [activeStep, setActiveStep] = useState(1);
  const [fade, setFade] = useState(false);
  const isMobile = useMediaQuery("(max-width: 767px)");

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setFade(true);
  //     setTimeout(() => {
  //       setActiveStep(prevStep => (prevStep % 6) + 1);
  //       setFade(false);
  //     }, 500);
  //   }, 6000);

  //   return () => clearInterval(interval);
  // }, []);

  const handleStepClick = (step) => {
    setFade(true);
    setTimeout(() => {
      setActiveStep(step);
      setFade(false);
    }, 500);
  };

  const steps = [
    { number: 1, title: 'Send Escrow Request', description: 'Buyer/Seller agrees to use Xcrow', image: Step1Image },
    { number: 2, title: 'Accept Request', description: 'Buyer can proceed to the next procedure', image: Step2Image },
    { number: 3, title: 'Transfer Crypto Escrow ', description: 'Buyer transfers the invoice amount, and seller delivers the product/service.', image: Step3Image },
    { number: 4, title: 'Document Proof', description: 'The buyer confirms that the product/service has been properly received and fills out the approval document for the release of funds.', image: Step4Image },
    { number: 5, title: 'Verifies Document', description: 'Xcrow will check the data and documents agreement.', image: Step5Image },
    { number: 6, title: 'Crypto Escrow Release ', description: 'The documents are verified, Xcrow will release the crypto escrow transaction.', image: Step6Image },
  ];

  const styles = {
    container: {
      maxWidth: '1290px',
      margin: '0 auto',
      padding: isMobile ? '20px' : '40px 20px',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: 'center',
    },
    titleSection: {
      textAlign: 'center',
    },
    title: {
      fontSize: isMobile ? '30px' : '40px',
      fontWeight: 'bold',
      background: 'linear-gradient(90deg, #FFFFFF 0%, #ACD5ED 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    stepsContainer: {
      display: 'flex',
      flexDirection: isMobile ? 'row' : 'column',
      alignItems: isMobile ? 'center' : 'flex-start',
      justifyContent: isMobile ? 'space-around' : 'flex-start',
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      flex: '1',
      paddingRight: isMobile ? '0' : '40px',
      marginBottom: isMobile ? '20px' : '0',
    },
    stepItem: (number) => ({
      display: 'flex',
      alignItems: 'center',
      marginBottom: isMobile ? '0' : '10px',
      marginRight: isMobile ? '10px' : '0',
      position: 'relative',
      height: number === 6 ? '70px' : 'auto',
    }),
    stepButtonContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    stepButton: (isActive) => ({
      background: isActive ? '#E7E4E2' : '#3E5466',
      color: isActive ? '#214D73' : '#FFFFFF',
      border: ' transparent',
      borderRadius: '50%',
      width: isMobile ? '50px' : '75px',
      height: isMobile ? '50px' : '75px',
      fontSize: isMobile ? '1.2rem' : '2rem',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      boxSizing: 'border-box',
    }),
    dashedLine: {
      marginTop: '10px',
      borderLeft: '1px dashed #E7E4E2',
      height: '30px',
    },
    stepDescription: (number) => ({
      color: '#ffffff',
      fontSize: isMobile ? '0.75rem' : '1rem',
      textAlign: 'left',
      marginLeft: isMobile ? '10px' : '20px',
      marginBottom: number === 6 ? '0px' : '20px',
      maxWidth: isMobile ? '140px' : '457px',
    }),
    contentContainer: {
      flex: '2',
      textAlign: 'center',
      padding: isMobile ? '10px' : '20px',
      borderRadius: '10px',
      maxWidth: '600px',
      minHeight: isMobile ? '300px' : '567px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      order: isMobile ? '-1' : 'unset', // Places contentContainer on top for mobile
      marginBottom: isMobile ? '20px' : '0', // Adds spacing for mobile view
    },
    fade: {
      opacity: fade ? 0 : 1,
      transition: 'opacity 0.5s ease-in-out',
    },
  };

  return (
    <section
      style={{
        background: 'radial-gradient(circle at center top, #0582CA 0%, #0972B0 13%, #0E6197 21%, #0D527E 27%, #134264 37%, #16324A 100%)',
        paddingTop: '1rem',
        padding: '4rem 0',
        paddingBottom: '4rem',
        fontFamily: 'Poppins',
      }}
    >
      <div style={styles.titleSection}>
        <h2 style={{ ...styles.title, marginBottom: "0px" }}>How Xcrow Works to Protect You</h2>
      </div>

      <div style={styles.container}>
        {/* Content Container with Image or Animation - Conditionally placed at the top for mobile */}


        {/* Steps Container */}
        <div style={styles.stepsContainer}>
          {steps.map((step, index) => {
            const isActive = activeStep === step.number;
            const lineHeight = step.description.length > 50 ? '60px' : '30px';

            return (
              <React.Fragment key={index}>
                <div style={styles.stepItem(step.number)} onClick={() => handleStepClick(step.number)}>
                  <div style={styles.stepButtonContainer}>
                    <button style={styles.stepButton(isActive)}>
                      {step.number}
                    </button>
                    {!isMobile && index < steps.length - 1 && (
                      <div style={{ ...styles.dashedLine, height: lineHeight }}></div>
                    )}
                  </div>
                  <div style={styles.stepDescription(step.number)}>
                    <h4 style={{ color: isActive ? '#F4E37B' : '#FFFFFF', fontWeight: 'bold', fontSize: '18px', marginBottom: '0px' }}>{step.title}</h4>
                    <p>{step.description}</p>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
        <div style={{ ...styles.contentContainer, ...styles.fade }} data-aos="fade-up">
          {steps[activeStep - 1].image ? (
            <img src={steps[activeStep - 1].image} alt={`Step ${activeStep}`} style={{ width: '100%', height: 'auto', maxWidth: isMobile ? '80%' : '100%' }} />
          ) : (
            <Lottie options={{ loop: true, autoplay: true, animationData }} height={isMobile ? 300 : 567} width={isMobile ? 300 : 567} />
          )}
        </div>
      </div>
    </section>
  );
};

export default Platform;
